module.exports = __webpack_public_path__ + "img/discover3.99016bc2.png";